/* @flow weak */
import AuthActions from 'auth/AuthActions';
import Button from 'components/Button.jsx';
import cx from 'classnames';
import ActivityRecipient from 'entities/ActivityRecipient';
import EventTrackingConstants from 'payments/constants/EventTrackingConstants';
import FocusEventTrigger from 'components/FocusEventTrigger.jsx';
import Form from 'components/Form.jsx';
import FormInput from 'components/FormInput.jsx';
import humanparser from 'humanparser';
import LoadingIndicator from 'components/LoadingIndicator.jsx';
import React, { Component, PropTypes } from 'react';
import Text from 'components/Text.jsx';
import ToastActions from 'actions/ToastActions';
import User from 'entities/User';
import UserActions from 'user/UserActions';

import './styles/PaymentViewConfirmationEmailAuthentificator.scss';

class PaymentViewConfirmationEmailAuthentificator extends Component {
  static propTypes = {
    recipient: PropTypes.instanceOf(ActivityRecipient).isRequired,
    onAuthSuccess: React.PropTypes.func.isRequired,
    authStatus: React.PropTypes.string,
  };

  state = {
    loadingUserProfile: true,
    loading: false,
  };

  componentDidMount() {
    const onSuccess = (userProfile) => {
      this.setState({ userProfile, loadingUserProfile: false });
    };

    const onFail = () => {
      this.setState({ loadingUserProfile: false });
    };

    User
      .loadProfile({ user_identifier: this.props.recipient.getAddress() })
      .then(onSuccess, onFail);
  }

  canSignInWithPassword(profile) {
    return profile && !profile.needs.password;
  }

  handleCreateAccount(data) {
    const email = this.props.recipient.getAddress();
    const human = humanparser.parseName(this.props.recipient.getName());
    const userData = {
      email,
      password: data.password,
      first_name: human.firstName,
      last_name: human.lastName,
      role: '', /* !!DO NOT REMOVE THIS!!! otherwise it will default to teacher */
    };

    const onFailure = (err) => ToastActions.showAPIError(err);

    return UserActions
      .create(userData)
      .then(this.props.onAuthSuccess, onFailure);
  }

  handleSignIn(data) {
    return AuthActions
      .signIn(this.props.recipient.getAddress(), data.password)
      .then(this.props.onAuthSuccess, () => {
        ToastActions.showErrorToast('Invalid email address or password.');
      });
  }

  render() {
    if (this.state.loadingUserProfile) {
      return <LoadingIndicator />;
    }

    let field = 'Create a password to complete your account';
    let placeholder = 'New password';
    let buttonText = 'Sign up';
    let buttonElementName = 'sign_up';
    let inputElementName = 'add_password';
    let handleSubmit = this.handleCreateAccount.bind(this);

    if (this.canSignInWithPassword(this.state.userProfile)) {
      field = 'Enter your Remind password to sign in';
      placeholder = 'Enter your Remind password';
      buttonText = 'Log in';
      buttonElementName = 'log_in';
      inputElementName = 'enter_password';
      handleSubmit = this.handleSignIn.bind(this);
    }

    const submitWrapper = data => {
      this.setState({ loading: true });

      handleSubmit(data).then(
        () => this.setState({ loading: false }),
        () => this.setState({ loading: false })
      );
    };

    return (
      <div className={cx('PaymentViewConfirmationEmailAuthentificator', this.props.className)}>
        <Form onSubmit={submitWrapper}>
          <div className="PaymentViewConfirmationEmailAuthentificator-form-field">
            <Text weight="bold">{field}</Text>
          </div>
          <FocusEventTrigger
            eventScreenName={EventTrackingConstants.PAYMENT_RECEIPT}
            eventElementName={inputElementName}>
            <FormInput
              type="password"
              autoComplete="current-password"
              name="password"
              autofocus
              placeholder={placeholder}
              required
              size="large"
              validations="minLength:1"
            />
          </FocusEventTrigger>
          <Button
            type="submit"
            level="primary"
            loading={this.state.loading}
            eventScreenName={EventTrackingConstants.PAYMENT_RECEIPT}
            className="PaymentViewConfirmationEmailAuthentificator-button"
            eventElementName={buttonElementName}>
            {buttonText}
          </Button>
        </Form>
      </div>
    );
  }
}

export default PaymentViewConfirmationEmailAuthentificator;



// WEBPACK FOOTER //
// ./src/payments/components/PaymentViewConfirmationEmailAuthentificator.jsx